







































import ScheduleComponent from '../scheduleblock';
import Noschedule from '../noschedule';
import { AppText } from '@/uikit';
import { format } from 'date-fns';
import ShedulerCalendar
  from "@/components/parts/catalog/card/components/tabs/schedule/components/schedulecalendar/SchedulerCalendar.vue";
import OrdersStat from '@/components/parts/orders-stat/OrdersStat.vue';
export default {
  inject: ['$api'],
  components: {
    OrdersStat,
    ShedulerCalendar,
    AppText,
    Noschedule,
    ScheduleComponent,
  },
  props: {
    item: {},
  },
  computed: {
    studyPeriod() {
      return `c ${format(this.item.schedule_date_from, 'DD.MM.YYYY')} г. по ${format(
        this.item.schedule_date_to,
        'DD.MM.YYYY'
      )} г.`;
    },
    admissionPlan() {
      return `от ${this.item.size_min} до ${this.item.size_max} человек`
    }
  }
};



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/parts/catalog/card/components/tabs/schedule/components/schedulecard/ScheduleCard.vue